import { Controller } from "@hotwired/stimulus"

// A súmula é impressa via window.print() direto no iPhone (ver
// share_controller.js), sem passar pelo servidor. O pipeline de impressão do
// iOS/AirPrint pra <input> lê o atributo HTML `value`, não a propriedade do
// DOM que o navegador atualiza enquanto a pessoa digita — então um nome
// escrito à mão num campo em branco da escalação não aparecia na folha
// impressa até a página recarregar do zero (ex.: depois de clicar em
// "Salvar súmula"), que é o único momento em que o Rails recoloca o valor
// digitado dentro do atributo `value=` do HTML. Mantendo o atributo
// sincronizado a cada tecla, a impressão já sai correta sem precisar salvar
// primeiro.
export default class extends Controller {
  sync(event) {
    event.target.setAttribute("value", event.target.value)
  }
}
